import api from '@/api';
import { API_BASE_URL } from '../..';
import {
  CompanyReportFormValues,
  CompanyReportRequest,
} from '@/core/domain/reports/company/Company.types';

const CONTROLLER_URL = `${API_BASE_URL}/company-report-settings`;

export async function getCompanieReportConfig(id: string) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, {})) as unknown;
  return result as CompanyReportFormValues;
}

export async function getCompanieReportConfigPublic(id?: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/public/${id}`,
    {},
  )) as unknown;
  return result as CompanyReportFormValues;
}

export async function putCompaniesReportConfig({
  id,
  ...params
}: CompanyReportRequest) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}`,
    params,
    {},
  )) as unknown;
  return result as CompanyReportFormValues;
}
